// extracted by mini-css-extract-plugin
export default {"suspenseSections":"styles_suspenseSections__jigIz","heading":"styles_heading__h0AMr","codesCheckBoxListWrapper":"styles_codesCheckBoxListWrapper__WnYRS"};